import script from "./RangeSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./RangeSlider.vue?vue&type=script&setup=true&lang=js"

import "./RangeSlider.vue?vue&type=style&index=0&id=4c7bea3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c7bea3e"]])

export default __exports__